import { drawCartesianAxes, seriesCategories, valueOf } from './axes.js';
import { hexToRgba } from '../core/utils.js';

function draw(chart, ctx, progress) {
  const categories = seriesCategories(chart.options.series);
  const { yToPixel, xForIndex } = drawCartesianAxes(chart, ctx, categories);
  const hitAreas = [];
  const zeroY = yToPixel(0);

  chart.options.series.forEach((s, si) => {
    const color = s.color || chart.options.colors[si % chart.options.colors.length];
    const points = s.data.map((d, i) => ({ px: xForIndex(i), py: yToPixel(valueOf(d)), value: valueOf(d), label: typeof d === 'object' ? d.x ?? d.label : i }));
    const visibleCount = Math.max(1, Math.round(points.length * progress));
    const visiblePoints = points.slice(0, visibleCount);

    ctx.beginPath();
    visiblePoints.forEach((p, i) => {
      if (i === 0) ctx.moveTo(p.px, p.py);
      else ctx.lineTo(p.px, p.py);
    });
    if (visiblePoints.length) {
      ctx.lineTo(visiblePoints[visiblePoints.length - 1].px, zeroY);
      ctx.lineTo(visiblePoints[0].px, zeroY);
      ctx.closePath();
    }
    ctx.fillStyle = hexToRgba(color, 0.25);
    ctx.fill();

    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();
    visiblePoints.forEach((p, i) => {
      if (i === 0) ctx.moveTo(p.px, p.py);
      else ctx.lineTo(p.px, p.py);
    });
    ctx.stroke();

    if (progress >= 1) {
      points.forEach((p) => {
        hitAreas.push({
          contains: (mx, my) => Math.hypot(mx - p.px, my - p.py) <= 8,
          distance: (mx, my) => Math.hypot(mx - p.px, my - p.py),
          tooltipX: p.px,
          tooltipY: p.py,
          label: `<b>${s.name || 'Series ' + (si + 1)}</b><br>${p.label}: ${p.value}`,
          raw: { seriesIndex: si, seriesName: s.name, dataIndex: points.indexOf(p), x: p.label, y: p.value },
        });
      });
    }
  });

  return hitAreas;
}

const AreaChart = { draw };
export default AreaChart;
